export default __webpack_public_path__ + "static/media/d11.9d02e682.png";